import { render, staticRenderFns } from "./FaceSearchModal.vue?vue&type=template&id=034c7a3d&scoped=true&"
import script from "./FaceSearchModal.vue?vue&type=script&lang=js&"
export * from "./FaceSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./FaceSearchModal.vue?vue&type=style&index=0&id=034c7a3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c7a3d",
  null
  
)

export default component.exports